module.controller('techniqueDetailCtrl', [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService', 'ASEBIOL_CONSTANTS', techniqueDetailCtrlFn ]);

function techniqueDetailCtrlFn($scope, $rootScope, $state, regulationService, alertService, ASEBIOL_CONSTANTS) {

	$scope.validation = {
		name : {
			maxlength : 255
		},
		sigla : {
			maxlength : 5
		},
		description : {
			maxlength : 500
		}
	};
	$scope.operationType = $state.current.data.type;
	var isUpdate = $scope.operationType == 'update';

	$scope.idRegulation = $state.params.idRegulation;
	$scope.idAnalysis = $state.params.idAnalysis;
	$scope.idTechnique = $state.params.idTechnique;
	
	if($state.params.type){
	$scope.idTypeResult = $state.params.type;
	}
	$scope.technique = {
		MinAmountUnits : {},
		ResultTypeUnits : {},
		resulttype : null,
		presenceAbsenceLimit : false,
		dilutions: {}
	};
	$scope.loading = false;
	$scope.loadingSM = false;
	$scope.contact = {};
	$scope.CNT = ASEBIOL_CONSTANTS;
	$scope.pageSize = 5;
	
	

	/**
	 * 
	 */
	$scope.load = function(idRegulation, idAnalysis, idTechnique,idType) {

		$scope.loading = true;
		

		regulationService.getTechnique($scope.idRegulation, idAnalysis, idTechnique,idType).then(function(response) {
			$scope.loading = false;

			var responseData = response.getData();
			$scope.technique = {
				name : responseData.name,
				dilution : responseData.dilutions,
				resulttype : responseData.resulttype,
				upperRange : responseData.upperRange,
				lowerRange : responseData.lowerRange,
				upperLimit : responseData.upperLimit,
				lowerLimit : responseData.lowerLimit,
				description : responseData.description,
				minAmount : responseData.minAmount,
				active : responseData.active,
				sigla : responseData.sigla,
				MinAmountUnits : {
					selected : [ {
						id : responseData.minAmountUnits.id,
						name : responseData.minAmountUnits.name,
						value : responseData.minAmountUnits.value,
						category : responseData.minAmountUnits.category,
						parent : responseData.minAmountUnits.parent,
						type : responseData.minAmountUnits.type
					} ]
				},
				samplingMethods : responseData.samplingMethods,
				dilutions : {
					selected : responseData.dilutions
				},
				numTubes: responseData.numTubes
			};
			if (responseData.resultTypeUnits) {
				$scope.technique.ResultTypeUnits = {
					selected : [ {
						id : responseData.resultTypeUnits.id,
						name : responseData.resultTypeUnits.name,
						value : responseData.resultTypeUnits.value,
						category : responseData.resultTypeUnits.category,
						parent : responseData.resultTypeUnits.parent,
						type : responseData.resultTypeUnits.type
					} ]
				}
			}

			if(responseData.presenceAbsenceLimit){
				if(responseData.presenceAbsenceLimit == PRESENCE_ABSENCE_LIMIT.PRESENCE.enumName){
					$scope.technique.presenceAbsenceLimit = true;	
				}
				else if(responseData.presenceAbsenceLimit == PRESENCE_ABSENCE_LIMIT.ABSENCE.enumName){
					$scope.technique.presenceAbsenceLimit = false;
				}
			}
			
			$scope.technique.resulttype = [ getConstantById(eval('TECHNIQUE_TYPE'), $scope.technique.resulttype) ];

		}, function(response) {
			$scope.loading = false;
		});
	};

	/**
	 * 
	 */
	$scope.sendAction = function() {
		if($scope.validateTechniqueData()){
			if ($scope.operationType == 'create') {
				$scope.create();
			} else {
				$scope.update();
			}	
		}
	};

	$scope.validateTechniqueData = function(){
		var dilutions = $scope.technique.dilutions;
		
		if(dilutions == undefined || dilutions == null){
			alertService.showWarning('Campo diluciones es obligatorio');
			return false;
		}
		else if(dilutions.selected == undefined || dilutions.selected == null){
			alertService.showWarning('Campo diluciones es obligatorio');
			return false;
		}
		
		if(dilutions.selected.length <= 0){
			alertService.showWarning('Campo diluciones es obligatorio');
			return false;
		}
		else{
			// validate all values are numbers between respective range
			var dilutions = $scope.technique.dilutions.selected;
			for(var i = 0; i < dilutions.length; i++){
				if(isNaN(dilutions[i])){
					alertService.showWarning('Campo diluciones solo puede contener números entre -10 y 0');
					return false;
				}
				else{
					
					var dilu = dilutions[i];
					if(dilu > 0 || dilu < -10){
						alertService.showWarning('Campo diluciones solo puede contener números entre -10 y 0');
						return false;	
					}
				}
			}
		}
		
		return true;
	};
	
	/**
	 * 
	 */
	$scope.create = function() {
		alertService.showSwtQuestion('Crear Técnica', function() {
			$scope.loading = true;

			var createModel = {
				name : $scope.technique.name,
				description : $scope.technique.description,
				sigla : $scope.technique.sigla,

			};


			regulationService.createTechnique($scope.idRegulation, $scope.idAnalysis, createModel).then(function(response) {
				$scope.loading = false;
				alertService.showSuccess('Técnica creada satisfactoriamente');
				var id = response.getData().id;
				$state.go('home.techniqueUpdate', {
					idRegulation : $scope.idRegulation,
					idAnalysis : $scope.idAnalysis,
					idTechnique : id
				});
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	/**
	 * 
	 */
	$scope.update = function() {
		alertService.showSwtQuestion('Actualizar Técnica en la normativa', function() {
			$scope.loading = true;

			var updateModel = {
				name : $scope.technique.name,
				dilutions : $scope.technique.dilutions,
				resulttype : $scope.technique.resulttype[0].enumName,
				upperRange : $scope.technique.upperRange,
				lowerRange : $scope.technique.lowerRange,
				upperLimit : $scope.technique.upperLimit,
				lowerLimit : $scope.technique.lowerLimit,
				description : $scope.technique.description,
				minAmount : $scope.technique.minAmount,
				idMinAmountUnits : $scope.technique.MinAmountUnits.selected[0].id,
				dilutions : $scope.technique.dilutions.selected,
				sigla : $scope.technique.sigla,
				numTubes: $scope.technique.numTubes
			
			};
			if($scope.idTypeResult){
				updateModel.idTypeResult = $scope.idTypeResult;
			}
			
			if($scope.technique.presenceAbsenceLimit == false){
				updateModel.presenceAbsenceLimit = PRESENCE_ABSENCE_LIMIT.ABSENCE.enumName;
			}
			else if($scope.technique.presenceAbsenceLimit == true){
				updateModel.presenceAbsenceLimit = PRESENCE_ABSENCE_LIMIT.PRESENCE.enumName;
			}

			if ($scope.technique.ResultTypeUnits && $scope.technique.ResultTypeUnits.selected){
				updateModel.idResultTypeUnits = $scope.technique.ResultTypeUnits.selected[0].id;
			}

			regulationService.updateTechnique($scope.idRegulation, $scope.idAnalysis, $scope.idTechnique, updateModel).then(function(response) {
				$scope.loading = false;
				alertService.showSuccess('Técnica actualizada satisfactoriamente');
				$state.go('home.regulationTechniqueList', {
					idRegulation : $scope.idRegulation,
					idAnalysis : $scope.idAnalysis
				});
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	$scope.methodTransform = function(newMethod) {
		var item = {
			id : -1,
			name : newMethod
		}
		return item;
	}

	$scope.addSamplingMethod = function() {
		$scope.loadingSM = true;
		$scope.inserted = {
			id : -1,
			name : ''
		};
		$scope.technique.samplingMethods.push($scope.inserted);
	};

	$scope.checkSamplingMethod = function(data) {
		if (data == '') {
			return "No puede estar vacio";
		}
	};
	
	$scope.checkUncertainty = function(data) {
		var regVal = $scope.CNT.REGEX_3DECIMAl.test(data);
		if (!regVal) {
			return "Debe ser un número positivo \r\n y máximo 3 decimales";
		}
	};

	$scope.onCancelSamplingMethod = function(idSM) {
		if (idSM < 0) {
			$scope.technique.samplingMethods.pop();
			$scope.loadingSM = false;
		}
	}

	$scope.removeSamplingMethod = function(sm) {
		$scope.loadingSM = true;
		regulationService.removeTechniqueSamplingMethod($scope.idRegulation, $scope.idAnalysis, $scope.idTechnique, sm.id).then(function(response) {
			$scope.loadingSM = false;
			var idx = findIndex($scope.technique.samplingMethods, sm.id);
			if (idx > -1)
				$scope.technique.samplingMethods.splice(idx, 1);
			alertService.showSuccess('Método ' + sm.name + ' eliminado satisfactoriamente');
		}, function(response) {
			$scope.loadingSM = false;
		});
	}

	$scope.saveSamplingMethod = function(name, idx, sm) {
		$scope.loadingSM = true;
		var model = name;
		if (sm.id == -1) {
			regulationService.addTechniqueSamplingMethod($scope.idRegulation, $scope.idAnalysis, $scope.idTechnique, model).then(function(response) {
				$scope.loadingSM = false;
				sm.id = response.getData().id;
				alertService.showSuccess('Método ' + sm.name + ' adicionado satisfactoriamente');
			}, function(response) {
				$scope.technique.samplingMethods.splice(idx, 1);
				$scope.loadingSM = false;
			});
		} else {
			var lastVal = sm;
			regulationService.updateTechniqueSamplingMethod($scope.idRegulation, $scope.idAnalysis, $scope.idTechnique, sm.id, model).then(
					function(response) {
						$scope.loadingSM = false;
						alertService.showSuccess('Método ' + sm.name + ' actualizado satisfactoriamente');
					}, function(response) {
						sm = lastVal;
						$scope.loadingSM = false;
					});
		}
	}

	function findIndex(array, id) {
		return array.findIndex(function(a) {
			return a.id == id;
		})
	}
	
	if (isUpdate) {
		$scope.load($scope.idRegulation, $scope.idAnalysis, $scope.idTechnique,$state.params.type);
	}

}
